export const SOFTLINE_API_ABC_ANALYSIS_STORAGE_LOCATION_SCAN =
  '/esl-service/esl/storage-location/scan/{{storageLocationCode}}'; // TODO: FROM OTHER SERVICE, WEIL ARMIN DAS NICHT AUSLIEFERN WILL NOCHMAL, DERWEIL
export const SOFTLINE_API_ABC_ANALYSIS_CATEGORIES =
  '/abcanalysis-service/abc-analysis/query';
export const SOFTLINE_API_ABC_ANALYSIS_PRODUCTS =
  '/abcanalysis-service/abc-analysis/query/{{segmentId}}';
export const SOFTLINE_API_ABC_ANALYSIS_FIELD_OK_QUERY = '/v1/bean/query/abcanalyse';
